import { render, staticRenderFns } from "./toutiao.vue?vue&type=template&id=5f6e0a56&"
import script from "./toutiao.vue?vue&type=script&lang=js&"
export * from "./toutiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports